/**
 * Company: SPHMedia
 * Description: Head/SEO for the /internal/subscribe route, extracted per the BH
 * {RouteName}MetaData convention. Emits the SEO tags plus the eShop manifest's
 * preload <link> tags, forcing noindex,nofollow on this precheckout page.
 */
import { toMetaDescriptors } from "@sphtech/eshop-partials-embed/precheckout/head/react-router";
import { subscribeHead } from "@sphtech/eshop-partials-embed/precheckout/head/subscribe";
import {
  pipe,
  withDefaultRobots,
} from "@sphtech/eshop-partials-embed/precheckout/head/tag";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { type MetaDescriptor } from "react-router";

import { SUBSCRIBE_DEFAULT_SEO } from "./utils/constants";
import type { SubscribeContext } from "./utils/types";

export function subscribeMeta(loaderData: SubscribeContext): MetaDescriptor[] {
  const seo =
    loaderData.type === ResponseType.SUCCESS
      ? loaderData.payload.seo
      : SUBSCRIBE_DEFAULT_SEO;
  const preload =
    loaderData.type === ResponseType.SUCCESS ? loaderData.payload.preload : [];

  // A precheckout page must never be indexed: drop any robots the payload carries
  // and force noindex,nofollow (withDefaultRobots only fills robots when absent).
  const input = { seo: { ...seo, robots: undefined }, preload };

  try {
    return pipe(
      subscribeHead(input),
      withDefaultRobots("noindex, nofollow"),
      toMetaDescriptors,
    );
  } catch {
    return [{ title: SUBSCRIBE_DEFAULT_SEO.title }];
  }
}
